export default "__VITE_ASSET__Bxr7$m0b__"